module.exports = __webpack_public_path__ + "static/scale-model-of-paul-w.-bryant-museum-in-tuscaloosa-alabama-be185b32a8cdda01492a3d53a42113c9.png";